<template>
  <div>
    <v-select
      v-model="postType"
      :items="selectablePostTypes"
      item-text="typeJa"
      item-value="type"
      style="width: 150px"
    />
    <div v-if="postType === 'normal'">
      <InputLabel label-name="アイキャッチ画像" class="text-caption pa-2" />
      <div
        class="p-postBasicEditor__eyecatch"
        @mouseover="eyecatchOverlay = true"
        @mouseleave="eyecatchOverlay = false"
      >
        <v-img :src="editingEyecatchableSrc" />
        <v-overlay absolute color="white" :value="eyecatchOverlay">
          <v-btn
            class="ma-1"
            fab
            x-small
            @click.stop="$emit('display-image-uploader-selecter')"
          >
            <v-icon>mdi-cog</v-icon>
          </v-btn>
          <v-btn
            v-if="eyecatchable"
            class="ma-1"
            color="error"
            fab
            x-small
            @click="$emit('delete-eyecatch')"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-overlay>
        <p class="text-caption error--text text-left mt-2">
          画像の表示がされない場合、画像URLやアップロードファイルが正常か確認してください。
        </p>
        <v-text-field v-model="eyecatchSourceUrl" :rules="[urlValidation]">
          <template v-slot:label>
            <InputLabel label-name="出典リンク" />
          </template>
        </v-text-field>
      </div>
    </div>
    <div v-else-if="postType === 'product'">
      <div class="p-postBasicEditor__eyecatch text-left">
        <ProductImageSlider
          v-if="typeof product.productImages === 'object'"
          :product-images="product.productImages.map((image) => image.file.url)"
          :height="productImageHeight"
        />
        <v-img
          v-else
          src="http://placehold.jp/eeeeee/cccccc/200x200.png?text=No%20Image"
          alt="noImage"
          :height="productImageHeight"
          tile
        />
        <p class="mt-5">{{ product.name ? product.name : '未選択' }}</p>
        <v-btn class="mt-15" @click="openSelectProductDialog()"
          >商品を選ぶ</v-btn
        >
      </div>
    </div>
    <v-dialog v-model="selectProductDialog" content-class="p-LeftPostBasicEdit-vdialog" width="800" @click:outside="selectProductDialog = false">
      <ProductSelecter
        @select-product="selectProduct"
      />
    </v-dialog>
  </div>
</template>

<script>
import InputLabel from '@/components/commons/formParts/inputLabel'
import formValidationUtils from '@/mixins/form_validation_utils'
import ProductSelecter from '@/components/postEditor/parts/ProductSelecter'
import SitePermissionUtils from '@/mixins/site_permission_utils'
import ProductUtils from '@/mixins/product_utils'
import ProductImageSlider from '../../commons/ProductImageSlider'

export default {
  components: {
    ProductImageSlider,
    InputLabel,
    ProductSelecter
  },
  mixins: [formValidationUtils, SitePermissionUtils, ProductUtils],
  props: {
    editingEyecatchableSrc: {
      type: String,
      required: true
    },
    eyecatchable: {
      type: Object,
      required: true
    },
    editPostType: {
      type: String,
      required: true
    },
    editProduct: {
      type: Object,
      required: true
    },
    editEyecatchSourceUrl: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      eyecatchOverlay: false,
      selectProductDialog: false,
      product: {},
      productImageHeight: '160'
    }
  },
  computed: {
    eyecatchSourceUrl: {
      get () {
        return this.editEyecatchSourceUrl
      },
      set (newValue) {
        this.$emit('input-eyecatch-source-url', newValue)
      }
    },
    postType: {
      get () {
        return this.editPostType
      },
      set (newValue) {
        this.$emit('change-post-type', newValue)
      }
    }
  },
  created () {
    this.product = this.editProduct
  },
  methods: {
    openSelectProductDialog () {
      this.selectProductDialog = true
    },
    selectProduct (product) {
      this.product = product
      this.$emit('select-product', this.product)
      this.selectProductDialog = false
    }
  }
}
</script>

<style scoped lang="sass">
.p-postBasicEditor
  &__eyecatch
    background-color: #efefef
    width: 240px
    height: 160px
    position: relative
    margin: 0 auto
</style>

<style>
.p-LeftPostBasicEdit-vdialog {
  margin-top: 70px;
}
</style>
